module.exports = __webpack_public_path__ + "static/media/galerija_2019 (43).756fac91.jpg";